import {onFind} from "@elements/init-modules-in-scope";
import {findIn, findAllIn, addClass, on, removeClass, removeAttribute, setAttribute, trigger} from '@elements/dom-utils';
import {getPrefixedDataSet} from "@elements/data-set-utils";
import {translate} from '@elements/translations';

const defaultOptions = {
    arrows: true,
    dots: false,
    slides: 1,
    dotsClass: 'scroll-slider__dot',
    arrowClass: 'scroll-slider__arrow',
    arrowPrevClass: 'scroll-slider__arrow--prev',
    arrowNextClass: 'scroll-slider__arrow--next',
    arrowIconClass: 'icon icon-arrow',
    dotsRenderFunction: defaultDotsRenderFunction,
    arrowRenderFunction: defaultArrowRenderFunction
};

const defaultSelectors = {
    base: '.js-scroll-slider',
    area: '.js-scroll-slider__area',
    item: '.js-scroll-slider__item',
    dotsContainer: '.js-scroll-slider__dots'
};

const INITIALIZED_EVENT = 'scroll-slider/initialized';

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createScrollSlider(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createScrollSlider(baseElement, options = defaultOptions, selectors = defaultSelectors) {
    options = {
        ...defaultOptions,
        ...options,
        ...getPrefixedDataSet('scroll-slider', baseElement)
    };

    let scrollArea = findIn(selectors.area, baseElement),
        prevButton,
        nextButton,
        dotsContainer;

    if (options.arrows === true) {
        prevButton = options.arrowRenderFunction(baseElement, 0, true, options);
        nextButton = options.arrowRenderFunction(baseElement, 1, false, options);
    }

    if (options.dots) {
        dotsContainer = findIn(selectors.dotsContainer, baseElement);
    }


    let items = findAllIn(selectors.item, baseElement);
    const scrollWidth = getScrollWidth(items[0]);

    //set initial scroll position to 0
    scrollArea.scrollLeft = 0;
    findAllIn(selectors.item, baseElement).map((item, index) => {
        if (index === 0) {
            addClass('is-active', item);
        }

        getActiveItems(item, index);

        if (dotsContainer) {
            let newDot = options.dotsRenderFunction(index, dotsContainer, options);

            on('click', function () {
                scrollTo(scrollArea, Math.round(item.getBoundingClientRect().left) + scrollArea.scrollLeft - Math.round(scrollArea.getBoundingClientRect().left))
            }, newDot);
        }
    });

    let dots;
    if (dotsContainer) {
        dots = findAllIn('.js-scroll-slider__dots-btn', dotsContainer);
    }

    if (nextButton || prevButton) {
        if(options.slides >= findAllIn(selectors.item, baseElement).length) {
            addClass('d-none', prevButton);
            addClass('d-none', nextButton);
        }

        on('click', function () {
            scrollTo(scrollArea, scrollArea.scrollLeft + scrollWidth)
        }, nextButton);


        on('click', function () {
            scrollTo(scrollArea, scrollArea.scrollLeft - scrollWidth)
        }, prevButton);
    }


    scrollArea.addEventListener('scroll', function () {
        if (dots) {
            dots.map((item) => removeClass('is-active', item));
        }

        if (nextButton) {
            removeAttribute('disabled', nextButton);
        }

        if (prevButton) {
            if(scrollArea.scrollLeft === 0) {
                setAttribute('disabled', true, prevButton);
            } else {
                removeAttribute('disabled', prevButton);
            }
        }

        items.map((item, index) => {
            removeClass('is-active', item);

            getActiveItems(item, index);
        });
    }, false);

    updateScrollWidth(items[0]);

    trigger(INITIALIZED_EVENT, baseElement);

    function getActiveItems(item, index) {
        let itemLeft = Math.round(item.getBoundingClientRect().left),
            areaOffsetLeft = Math.round(scrollArea.getBoundingClientRect().left),
            areaWidth = Math.round(scrollArea.getBoundingClientRect().width),
            areaPaddingLeft = Math.round(parseInt(getComputedStyle(scrollArea).paddingLeft));

        if(itemLeft + 2 >= areaPaddingLeft &&
            itemLeft + scrollWidth <= areaWidth + areaPaddingLeft + areaOffsetLeft &&
            itemLeft < areaWidth - areaPaddingLeft + areaOffsetLeft) {
            addClass('is-active', item);

            if (dots) {
                addClass('is-active', dots[index]);
            }

            //disable button if last item is active
            if (nextButton && items.slice(-1)[0] === item) {
                setAttribute('disabled', true, nextButton)
            }
        }
    }
}

export function scrollTo(scrollArea, scroll) {
    try {
        scrollArea.scroll({
            left: scroll,
            behavior: 'smooth'
        });
    } catch (e) {
        scrollArea.scrollLeft = scroll;
    }
}

export function getScrollWidth(item) {
    return Math.round(item.getBoundingClientRect().width);
}

function updateScrollWidth(item) {
    let delay = 250,
        throttled = false;

    window.addEventListener('resize', function() {
        if (!throttled) {
            getScrollWidth(item);
            throttled = true;
            setTimeout(function() {
                throttled = false;
            }, delay);
        }
    });
}

function defaultDotsRenderFunction(id = null, dotContainer, options) {
    let markupElement = document.createElement('div'),
        dotMarkup = `<button type="button" class="${options.dotsClass} js-scroll-slider__dots-btn ${id === 0 ? 'is-active' : ''}" data-id="${id+1}"></button>`;
    markupElement.innerHTML = dotMarkup;
    let newDot = markupElement.childNodes[0];
    dotContainer.appendChild(newDot);

    return newDot;
}
function defaultArrowRenderFunction(container, direction, disabled, options) {
    let markupElement = document.createElement('div'),
        arrowMarkup = `<button type="button" class="${options.arrowClass} ${direction === 0 ? options.arrowPrevClass : options.arrowNextClass}" ${disabled ? 'disabled' : ''}><span class="scroll-slider__arrow-icon ${options.arrowIconClass}" aria-label="${translate('scroll-slider-'+ direction + '')}" title="${translate('scroll-slider-'+ direction + '')}"></span></button>`;
    markupElement.innerHTML = arrowMarkup;
    let newArrow = markupElement.childNodes[0];
    container.appendChild(newArrow);

    return newArrow;
}